import React from 'react';
import './ModalListItem.scss';

export type ModalListItemProps = {
  item: {
    cardType?: string;
    cardImage?: string;
    statisticType?: string;
    variableLabel?: string;
  };
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
  onKeyDown?: () => void;
  onClick?: () => void;
  type?: string;
};

const ModalListItem: React.FC<ModalListItemProps> = ({
  item,
  onMouseEnter,
  onMouseLeave,
  onKeyDown,
  onClick,
  type = 'cardType',
}) => (
  <li
    key={item.cardType || item.statisticType}
    className={`${type} w-full flex items-center py-4 px-4 hover:surface-elevated-more`}
    role="presentation"
    onKeyDown={onKeyDown}
    onClick={onClick}
    onMouseEnter={onMouseEnter}
    onMouseLeave={onMouseLeave}>
    <span className="typo-text-12 px-4">{item.cardType || item.statisticType || item.variableLabel}</span>
  </li>
);

export default ModalListItem;
